import React from 'react';
import ReactDOM from 'react-dom/client';
import AppPublic from './AppPublic.tsx';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppPublic />
  </React.StrictMode>
);
